import { z } from 'zod';
import { addPublishWindowIssues, adminMetadataSchema, contentStatusChangeSchema, imageReferenceSchema, nonEmptyUpdate, publishWindowShape, slugSchema, } from './common.js';
const noticiaEditableShape = {
    titulo: z.string().min(1),
    slug: slugSchema,
    contenido: z.string().min(1),
    imagenUrl: imageReferenceSchema.nullable(),
    categoria: z.string().min(1),
};
const noticiaWriteShape = { ...noticiaEditableShape, ...publishWindowShape };
export const createNoticiaSchema = z
    .object({
    ...noticiaEditableShape,
    slug: slugSchema.optional(),
    status: publishWindowShape.status.optional(),
    publishAt: publishWindowShape.publishAt.optional(),
    unpublishAt: publishWindowShape.unpublishAt.optional(),
})
    .superRefine(addPublishWindowIssues);
export const updateNoticiaSchema = nonEmptyUpdate(z.object(noticiaWriteShape));
export const noticiaStatusChangeSchema = contentStatusChangeSchema;
export const publicNoticiaCardSchema = z.object({
    titulo: noticiaEditableShape.titulo,
    slug: noticiaEditableShape.slug,
    imagenUrl: noticiaEditableShape.imagenUrl,
    categoria: noticiaEditableShape.categoria,
    createdAt: adminMetadataSchema.shape.createdAt,
});
export const publicNoticiaCardListSchema = z.array(publicNoticiaCardSchema);
export const publicNoticiaCardFields = Object.freeze(Object.keys(publicNoticiaCardSchema.shape));
export const publicNoticiaSchema = publicNoticiaCardSchema.extend({
    contenido: noticiaEditableShape.contenido,
});
export const publicNoticiaFields = Object.freeze(Object.keys(publicNoticiaSchema.shape));
export const adminNoticiaSchema = z
    .object({ id: z.number().int().positive(), ...noticiaWriteShape })
    .extend(adminMetadataSchema.shape);
export const adminNoticiaListSchema = z.array(adminNoticiaSchema);
export const noticiaPreviewSchema = z.object({
    content: publicNoticiaSchema,
    effectiveVisibility: adminMetadataSchema.shape.effectiveVisibility,
    publishAt: publishWindowShape.publishAt,
    unpublishAt: publishWindowShape.unpublishAt,
});
//# sourceMappingURL=noticias.js.map